// src/lib/images.ts
export type VariantSet = {
  placeholder: string | null;
  avif: { sm: string; md: string; lg: string };
  webp: { sm: string; md: string; lg: string };
  fallback: string; // original
};

function trimSlashes(s: string) {
  return s.replace(/^\/+|\/+$/g, "");
}

function stripEpisodeDataPrefix(s: string) {
  return s.replace(/^episode-data\/+/, "");
}

export function buildOptimizedSources(
  bucketBase: string,
  storageRoot: string,
  originalName: string
): VariantSet {
  const base = originalName.replace(/\.[^.]+$/, "");
  const cleanBucket = trimSlashes(bucketBase);
  const cleanRoot = stripEpisodeDataPrefix(trimSlashes(storageRoot));
  const isAbsoluteUrl = cleanBucket.startsWith('http://') || cleanBucket.startsWith('https://');
  const root = isAbsoluteUrl ? `${cleanBucket}/${cleanRoot}` : `/${cleanBucket}/${cleanRoot}`;
  const opt  = `${root}/optimized`;

  return {
    placeholder: `${opt}/placeholder/${base}_blur.webp`,
    avif: {
      sm: `${opt}/avif/${base}_sm.avif`,
      md: `${opt}/avif/${base}_md.avif`,
      lg: `${opt}/avif/${base}_lg.avif`,
    },
    webp: {
      sm: `${opt}/webp/${base}_sm.webp`,
      md: `${opt}/webp/${base}_md.webp`,
      lg: `${opt}/webp/${base}_lg.webp`,
    },
    fallback: `${root}/${originalName}`,
  };
}
